<template>
  <div class="agent__view">
    <Transition name="bounce">
      <MapOverlay v-if="store.showMapOverlay" />
    </Transition>
    <ContentMap />
  </div>
</template>

<script>
import ContentMap from "../components/ContentMap.vue";
import MapOverlay from "../components/MapOverlay.vue";
import { useContentStore } from "@/store/content";

export default {
  components: {
    ContentMap,
    MapOverlay,
  },
  setup() {
    const store = useContentStore();
    return {
      store,
    };
  },
};
</script>

<style lang="scss" >
//had to add empty block to view, to be catchable from externals scss
.agent__view{
  
}
</style>@/store/content